import { Component } from '@inter-ikea-core/core';

/**
 * Added to products like the adjustable clothrail
 * that can be adjusted in the planner.
 */
export default class AdjustableComponent implements Component {
  static id = 3006;
  typeId = AdjustableComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return false;
  }
}
